export default __webpack_public_path__ + "static/media/s1_female.2f0e7b07.wav";